import React from "react";
import Footer from "../footer/Footer";
import "./styles/Root.scss";
import {AppState} from "../RootReducer";
import {connect} from "react-redux";

interface Props {
    children: any;
    footer: boolean;
    className? : string;
    style? : any;
    mobile?: boolean;
}

const Root: React.FC<Props> = (props: Props) => {
    return (
        <div className={"root-container " + (props.mobile ? " mobile " : "")+ (props.className ?  " " +props.className : "")} id={"pageContainer"} style={props.style ? props.style : {}}>
                <div className={`${props.className ? props.className : 'root'}-wrapper`}>
                {
                    props.children
                }
                </div>
                {
                    props.footer
                    ? <Footer />
                    : ''
                }
        </div>
    )
}

export default connect((state : AppState) => {
    return {
        mobile : state.settings.mobile
    }
})(Root);